import { type RouteConfig } from 'vue-router'

export const GalleryRouter: RouteConfig[] = [
  {
    path: '/gallery',
    component: async () => import('./Gallery.vue'),
  },
]
